import React from 'react'

const Error = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="text-center mt-5">
            <h1>Fakturan kan inte visas</h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-center">
          Vänligen försök igen om en stund eller kontakta kundtjänst.
        </div>
      </div>
    </div>
  )
}

export default Error
